import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { ClinicNavigationEnum } from '@core/enums/navigation.enum';
import { PatientInRouterService } from '@core/services/patient-in-router.service';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { ClinicDTO } from '../../apis/clinic/clinic.dto';
import { IUserStore } from '../../interfaces/interface';
import { FullNamePipe } from '../../pipes/full-name.pipe';
import { SignedUrlPipe } from '../../pipes/signed-url.pipe';
import { ClinicStore } from '../../stores/clinic.store';
import { UserStore } from '../../stores/user.store';
import { PlannerModalComponent } from '../planner-modal/planner-modal.component';
import { HeaderBasketComponent } from './basket/basket.component';

@UntilDestroy()
@Component({
  selector: 'app-header',
  imports: [
    TranslocoModule,
    PlannerModalComponent,
    HeaderBasketComponent,
    SignedUrlPipe,
    CommonModule,
    RouterModule,
    FullNamePipe,
  ],
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @ViewChild(PlannerModalComponent)
  plannerModal!: PlannerModalComponent;
  public fullName: string = '';
  public path: string = '';
  public clinic: ClinicDTO | null = null;
  public user: IUserStore | null = null;
  public patientId: number | null = null;

  constructor(
    private readonly clinicStore: ClinicStore,
    private readonly userStore: UserStore,
    private readonly router: Router,
    private route: ActivatedRoute,
    private patientInRouterService: PatientInRouterService,
  ) {
    this.trackPatientId();
  }

  ngOnInit(): void {
    this.user = this.userStore.get();
    this.fullName = this.user ? `${this.user.lastName} ${this.user.firstName}` : '';

    this.clinic = this.clinicStore.get();
    if (this.clinic) this.path = `clinics/${this.clinic.id}/logo`;

    this.setPatientIdFromRoute(this.route.root);
  }

  public logout(): void {
    this.router.navigate(['/sign-in']);
    this.userStore.set(null);
    localStorage.removeItem('token');
  }

  public goToTelediagnosis(): void {
    this.router.navigate([`/${ClinicNavigationEnum.telediagnosis}/${this.patientId}/${ClinicNavigationEnum.posture}`]);
  }
  public goToVideoconsultation(): void {
    this.router.navigate(['/telediagnosis/videoconsultation', this.patientId]);
  }

  public openPlanner(): void {
    this.plannerModal.openModal(this.patientId!);
  }

  private trackPatientId(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.setPatientIdFromRoute(this.route.root);
      });
  }

  private setPatientIdFromRoute(route: ActivatedRoute): void {
    while (route.firstChild) {
      route = route.firstChild;
    }
    const patientIDinRoute = route.snapshot.paramMap.get('patientId');
    this.patientId = patientIDinRoute ? +patientIDinRoute : null;
    if (this.patientId !== null && this.patientId !== undefined) {
      this.patientInRouterService.patientIdSubj.next(this.patientId);
    }
  }
}
